//@ts-ignore
import swal from 'sweetalert'
import Swal from 'sweetalert2'

export async function resultAlert(res: any, message?: any) {
  switch (res.resultCode) {
    case 0:
      await swal({
        title: '성공',
        text: message === undefined ? '성공적으로 처리되었습니다.' : message,
        icon: 'success',
        buttons: [false],
        timer: 2000,
      })
      break
    case 1:
      await swal({
        title: '실패',
        text: message === undefined ? '실패하였습니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 10:
      await swal({
        title: '실패',
        text: message === undefined ? '필수값이 누락되어있습니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 20:
      await swal({
        title: '실패',
        text: message === undefined ? '중복된 데이터입니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 30:
      await swal({
        title: '실패',
        text: message === undefined ? '데이터 형식이 맞지않습니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 40:
      await swal({
        title: '실패',
        text: message === undefined ? '입력하신 값이 허용범위를 초과하였습니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 41:
      await swal({
        title: '실패',
        text: message === undefined ? '권한이 없습니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 50:
      await swal({
        title: '실패',
        text: message === undefined ? '연관된 데이터가 존재합니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 200:
      await swal({
        title: '성공',
        text: message === undefined ? '성공적으로 처리되었습니다.' : message,
        icon: 'success',
        buttons: [false],
        timer: 2000,
      })
      break
    case 401:
      await swal({
        title: '실패',
        text: message === undefined ? '인증에 오류가 있습니다. 다시 로그인해주세요.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
    case 500:
      await swal({
        title: '실패',
        text: message === undefined ? '서버에 오류가 있습니다. 관리자에게 문의해주세요.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break

    default:
      await swal({
        title: '실패',
        text: message === undefined ? '알수없는 오류가 발생하였습니다.' : message,
        icon: 'error',
        buttons: [false],
        timer: 2000,
      })
      break
  }
}
export async function failAlert() {
  return await swal({
    title: '실패',
    text: '관리자에게 문의해주세요.',
    icon: 'error',
    buttons: [false],
    timer: 2000,
  })
}

export async function savedFailAlert() {
  return await swal({
    title: '실패',
    text: '먼저 저장을 완료해주세요.',
    icon: 'error',
    buttons: [false],
    timer: 2000,
  })
}

export const showDateRequiredAlert = async () => {
  await swal({
    title: '안내',
    text: '납기일자를 선택해야 합니다.',
    icon: 'warning',
    buttons: [false],
    timer: 2000,
  })
}

export const showNoDataAlert = async () => {
  await swal({
    title: '안내',
    text: '조회된 데이터가 없습니다.',
    icon: 'warning',
    buttons: [false],
    timer: 2000,
  })
}

export async function confirmAlert(
  type:
    | '삭제'
    | '초기화'
    | 'pass'
    | 'fail'
    | '등록'
    | '수정'
    | '생성'
    | '할당'
    | '할당취소'
    | '설치'
    | '설치취소'
    | '설치불가'
    | '설치가능'
    | 'AS등록'
    | 'AS취소'
    | 'AS완료'
    | '재사용'
    | '폐기처리'
    | '다운로드'
    | string,
  icon: string
) {
  return await swal({
    title: `${type}`,
    text: `${type} 하시겠습니까?`,
    icon: `${icon}`,
    buttons: {
      cancel: {
        text: `취소`,
        value: false,
        visible: true,
        className: 'fw-bold',
      },
      confirm: {
        text: `${type}`,
        value: true,
        visible: true,
        className: 'bg-primary fw-bold',
      },
    },

    className: 'fw-bold',
    dangerMode:
      type === '삭제' ||
      type === '설치취소' ||
      type === 'AS취소' ||
      type === '할당취소' ||
      type === '초기화',
  })
}

export async function imageSettingChangedAlert(trigger: boolean) {
  return await swal({
    title: '변경',
    text: `${trigger ? '변경되었습니다' : '해제되었습니다'}`,
    icon: 'info',
    buttons: [false],
    timer: 600,
  })
}

/**
 * A/S 원인을 고르는 확인창. 선택한 원인의 codeIdx를 돌려준다.
 *
 * targetText 를 넘기면 대상(수용가 번호·이름)을 문구에 함께 보여준다.
 */
/** A/S 원인 select 의 화살표 아이콘과 오른쪽 여백 */
const AS_SELECT_ARROW_INSET = '12px'
const AS_SELECT_ARROW =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'" +
  " fill='none' stroke='%237e8299' stroke-width='2' stroke-linecap='round'" +
  " stroke-linejoin='round'%3E%3Cpath d='M4 6l4 4 4-4'/%3E%3C/svg%3E\")"

export async function confirmASAlert(
  type: string,
  icon: any,
  res: any,
  targetText?: string
): Promise<number | false> {
  const options: Record<string, string> = {}
  res.data.res.forEach((code: any) => {
    // 코드의 실제 codeIdx를 값으로 쓴다.
    // 예전에는 목록 순번 + 1을 causeIdx로 보내, 코드가 하나라도 삭제되면
    // 그 뒤의 원인들이 조용히 다른 원인으로 등록됐다.
    options[String(code.codeIdx)] = code.codeName
  })
  // 제목이 이미 동작을 말하므로 본문은 "무엇에 대한 등록인지"만 남긴다.
  // 원인은 필수값이라 select 위에 라벨을 붙인다.
  const heading = targetText
    ? `<div style="font-weight:700;font-size:1.05em;color:#181c32;">${targetText}</div>`
    : `<div>${type} 하시겠습니까?</div>`
  const causeLabel =
    '<div style="text-align:left;margin-top:18px;margin-bottom:6px;font-weight:600;color:#3f4254;">원인</div>'

  const {value: selectedOption, isConfirmed} = await Swal.fire({
    title: `${type}`,
    html: `${heading}${causeLabel}`,
    icon: icon,
    input: 'select',
    inputOptions: options,
    inputPlaceholder: '원인을 골라주세요.',
    showCancelButton: true,
    confirmButtonText: `${type}`,
    confirmButtonColor: '#3085d6',
    cancelButtonText: '취소',
    // 되돌리기 어려운 쪽은 등록이다. 취소에 위험색(빨강)을 쓰지 않는다.
    cancelButtonColor: '#7e8299',
    reverseButtons: true,

    didOpen: () => {
      const selectElement = Swal.getInput()
      if (selectElement) {
        selectElement.style.fontFamily = 'Nanum Gothic, sans-serif'
        // 전역 스타일에 눌려 기본 테두리가 보이지 않아 직접 지정한다
        selectElement.style.border = '1px solid #e4e6ef'
        selectElement.style.borderRadius = '6px'
        selectElement.style.padding = '8px 12px'
        selectElement.style.backgroundColor = '#ffffff'
        selectElement.style.color = '#3f4254'
        selectElement.style.boxShadow = 'none'
        selectElement.style.boxSizing = 'border-box'

        // 브라우저 기본 화살표는 위치를 제어할 수 없어, 기본 표시를 끄고
        // 화살표를 배경으로 직접 그린다. AS_SELECT_ARROW_INSET 으로 여백 조절.
        selectElement.style.appearance = 'none'
        selectElement.style.backgroundImage = AS_SELECT_ARROW
        selectElement.style.backgroundRepeat = 'no-repeat'
        selectElement.style.backgroundPosition = `right ${AS_SELECT_ARROW_INSET} center`
        selectElement.style.backgroundSize = '14px'
        // 긴 원인명이 화살표와 겹치지 않도록 오른쪽 여백을 화살표 폭만큼 더 준다
        selectElement.style.paddingRight = 'calc(14px + 12px + 12px)'

        // select는 본문(html)의 형제라 좌우 여백 기준이 달라 라벨과 어긋난다.
        // 본문 컨테이너의 padding을 그대로 가져와 맞춘다. (버전별 기본값에 의존하지 않음)
        const htmlContainer = Swal.getHtmlContainer()
        if (htmlContainer) {
          const {paddingLeft, paddingRight} = window.getComputedStyle(htmlContainer)
          selectElement.style.marginLeft = paddingLeft
          selectElement.style.marginRight = paddingRight
          selectElement.style.marginTop = '0'
          selectElement.style.width = `calc(100% - ${paddingLeft} - ${paddingRight})`
        }
        selectElement.addEventListener('click', (event) => {
          event.stopPropagation()
        })
      }
    },
  })
  if (isConfirmed) {
    if (selectedOption) {
      return Number(selectedOption)
    } else {
      await Swal.fire({
        icon: 'warning',
        title: '사유는 필수값입니다.',
        text: '사유를 선택해주세요!',
        confirmButtonText: '확인',
        confirmButtonColor: '#3085d6',
      })
      // return이 없으면 다시 고른 원인이 버려져 등록이 조용히 취소된다
      return await confirmASAlert(type, icon, res, targetText)
    }
  } else {
    return false
  }
}
export async function confirmASCancleAlert(type: string, icon: any, targetText?: string) {
  const {isConfirmed} = await Swal.fire({
    title: `${type}`,
    html: targetText
      ? `<div style="font-weight:700;font-size:1.05em;color:#181c32;">${targetText}</div>`
      : `${type} 하시겠습니까?`,
    icon: icon,
    showCancelButton: true,
    confirmButtonText: `${type}`,
    confirmButtonColor: '#3085d6',
    cancelButtonText: '취소',
    cancelButtonColor: '#7e8299',
    reverseButtons: true,
  })
  if (isConfirmed) {
    return true
  } else {
    return false
  }
}

export async function noDataAlert() {
  return await swal({
    title: `경고`,
    text: `선택된 데이터가 없습니다.`,
    icon: `warning`,
    buttons: [false],
    timer: 2000,
  })
}
export async function normalAlert(message: string) {
  return await swal({
    title: `경고`,
    text: `${message}`,
    icon: `warning`,
    buttons: [false],
    timer: 2000,
  })
}
export async function validationAlert(message: string, icon: string, time: number = 1400) {
  return await swal({
    title: `확인`,
    text: `${message}`,
    icon: icon,
    buttons: [false],
    timer: time,
  })
}
export async function customConfirm(text: string, icon: string, button: string) {
  return await swal({
    title: '경고',
    text: `${text}`,
    icon: `${icon}`,
    buttons: {
      cancel: {
        text: `취소`,
        value: false,
        visible: true,
        className: 'fw-bold',
      },
      confirm: {
        text: `${button}`,
        value: true,
        visible: true,
        className: 'bg-primary fw-bold',
      },
    },
    className: 'fw-bold',
  })
}
export async function playConfirm(title: string, text: string, icon: string, button: string) {
  const result = await Swal.fire({
    title,
    html: text.replace(/\n/g, '<br>'),
    icon: icon as 'info' | 'success' | 'warning' | 'error' | 'question',
    showCancelButton: true,
    confirmButtonText: button,
    cancelButtonText: '취소',
    confirmButtonColor: '#0d6efd',
    cancelButtonColor: '#6c757d',
    reverseButtons: true,
    customClass: {
      title: 'swal-install-title',
      htmlContainer: 'swal-install-text',
      confirmButton: 'fw-bold swal-install-btn',
      cancelButton: 'fw-bold swal-install-btn',
    },
  })
  return result.isConfirmed
}

export async function swal2Confirm(title: string, html: string, icon: 'info' | 'success' | 'warning' | 'error' | 'question', confirmText: string) {
  const result = await Swal.fire({
    title,
    html,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: '취소',
    confirmButtonColor: '#0d6efd',
    customClass: {
      title: 'fw-bold',
      confirmButton: 'fw-bold',
      cancelButton: 'fw-bold',
    },
  })
  return result.isConfirmed
}

export const loginAlert = async (name: string) => {
  return await swal({
    title: '안녕하세요, 미터리움입니다.',
    content: {
      element: 'div',
      attributes: {
        innerHTML: `<div class="row"><div class="mb-4" style="text-align: center;">${name}님 환영합니다.</div><div class="fw-bold" style="text-align: center;">미터리움을 통해 스마트한 미터링과 <br />검침의 미래를 경험해보세요.</div></div>`,
      },
    },
    icon: 'success',
    buttons: [false],
    timer: 1500,
  })
}

export const loginFailAlert = async () => {
  return await swal({
    title: '로그인 실패',
    text: '로그인 정보가 올바르지 않습니다.',
    icon: 'error',
    buttons: [false],
    timer: 1500,
  })
}

export const ErrorAlert = async (message: string) => {
  return await swal({
    title: '실패',
    text: `${message}`,
    icon: 'error',
    buttons: [false],
    timer: 1500,
  })
}
export const SuccessAlert = async (message: string) => {
  return await swal({
    title: '성공',
    text: `${message}`,
    icon: 'success',

    buttons: [false],
    timer: 1500,
  })
}
export const installConfirm = async (text: string, icon: string, button: string) => {
  return await swal({
    title: '경고',
    content: {
      element: 'div',
      attributes: {
        innerHTML: `<div class="row"><div class="mb-2" style="text-align: center;">${text}</div><div class="fw-bold text-danger" style="text-align: center;">설치 중인 데이터는 사라집니다.</div></div>`,
      },
    },
    icon: `${icon}`,
    buttons: {
      cancel: {
        text: `취소`,
        value: false,
        visible: true,
        className: 'fw-bold',
      },
      confirm: {
        text: `${button}`,
        value: true,
        visible: true,
        className: 'bg-primary fw-bold',
      },
    },
    className: 'fw-bold',
  })
}
export const asConfirm = async (text: string, icon: string, button: string) => {
  return await swal({
    title: '경고',
    content: {
      element: 'div',
      attributes: {
        innerHTML: `<div class="row"><div class="mb-2" style="text-align: center;">${text}</div><div class="fw-bold text-danger" style="text-align: center;">A/S 중인 데이터는 사라집니다.</div></div>`,
      },
    },
    icon: `${icon}`,
    buttons: {
      cancel: {
        text: `취소`,
        value: false,
        visible: true,
        className: 'fw-bold',
      },
      confirm: {
        text: `${button}`,
        value: true,
        visible: true,
        className: 'bg-primary fw-bold',
      },
    },
    className: 'fw-bold',
  })
}

export async function confirmPhotoAlert(text: any) {
  return await swal({
    title: `확인`,
    content: {
      element: 'p',
      attributes: {
        innerHTML: `${text}`,
      },
    },
    icon: `info`,
    buttons: {
      cancel: {
        text: `취소`,
        value: false,
        visible: true,
        className: 'fw-bold',
      },
      confirm: {
        text: `확인`,
        value: true,
        visible: true,
        className: 'bg-primary fw-bold',
      },
    },

    className: 'fw-bold',
  })
}

export async function warningPhotoAlert() {
  return await swal({
    title: '실패',
    text: `한번에 가능한 다운로드 수량은 100개입니다`,
    icon: 'error',
    buttons: [false],
    timer: 4000,
  })
}

export const newVersionAlert = async () => {
  return await swal({
    title: '새로운 버전 배포',
    text: '페이지를 새로고침합니다.',
    icon: 'info',
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const busanAlert = async () => {
  return await swal({
    title: '개인정보 주의',
    text: '부산 사업소의 경우 개인정보 취급에 주의 해주시기 바랍니다.',
    icon: 'info',
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const noFindDataAlert = async () => {
  return await swal({
    title: '실패',
    text: '해당 검색어로 확인 불가능합니다. 다시 확인해주세요.',
    icon: 'warning',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const firstDataAlert = async () => {
  return await swal({
    title: '실패',
    text: '첫번째 수용가 입니다.',
    icon: 'info',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const lastDataAlert = async () => {
  return await swal({
    title: '실패',
    text: '마지막 수용가 입니다.',
    icon: 'info',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const noPhotoAlert = async () => {
  return await swal({
    title: '실패',
    text: '선택 수용가에 사진첩이 있는 수용가가 없습니다.',
    icon: 'warning',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const noFotaAlert = async () => {
  return await swal({
    title: '정보',
    text: 'FOTA 가능한 펌웨어 버전이 아닙니다.',
    icon: 'info',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

export const noNewImageAlert = async (text: any) => {
  return await swal({
    title: '실패',
    content: {
      element: 'div',
      attributes: {
        innerHTML: `<div class="row"><div class="mb-2" style="text-align: center;">${text}</div><div class="fw-bold text-danger" style="text-align: center;"></div></div>`,
      },
    },
    icon: 'error',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}

/**
 * 되돌리기 어려운 동작 전에 한 번 묻는 확인창.
 *
 * confirmAlert 는 "{동작} 하시겠습니까?" 로 문구가 정해져 있어, 무엇이 얼마나
 * 바뀌는지 함께 알려야 하는 경우에 이쪽을 쓴다.
 */
export const confirmTextAlert = async (text: string, button: string = '확인') => {
  return await swal({
    title: '확인',
    content: {
      element: 'div',
      attributes: {
        innerHTML: `<div class="row"><div class="mb-2" style="text-align: center;">${text}</div></div>`,
      },
    },
    icon: 'warning',
    buttons: {
      cancel: {
        text: '취소',
        value: false,
        visible: true,
        className: 'fw-bold',
      },
      confirm: {
        text: button,
        value: true,
        visible: true,
        className: 'bg-primary fw-bold',
      },
    },
    className: 'fw-bold',
  })
}

export const noTextAlert = async (text: any) => {
  return await swal({
    title: '실패',
    content: {
      element: 'div',
      attributes: {
        innerHTML: `<div class="row"><div class="mb-2" style="text-align: center;">${text}</div><div class="fw-bold text-danger" style="text-align: center;"></div></div>`,
      },
    },
    icon: 'error',
    timer: 2000,
    buttons: {
      confirm: {
        text: '확인',
        value: true,
        className: 'fw-bold',
      },
    },
  })
}
